/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {PersonDTOModel} from './person-DTO.model';
import {UserDTOModel} from './user-DTO.model';
import {JSONable} from '@irian-ro/abstract-resource';

export class EmployeeDTOModel extends JSONable {
  uuid: string | undefined = undefined;
  personDTO: PersonDTOModel | undefined = undefined;
  userDTO: UserDTOModel | undefined = undefined;
  pid: string | undefined = undefined;
  phoneNumber: string | undefined = undefined;
  email: string | undefined = undefined;
  department: string | undefined = undefined;
  validFrom: string | undefined = undefined;
  validTo: string | undefined = undefined;
  legalEntityUuid: string | undefined = undefined;
}
